module.exports = __webpack_public_path__ + "static/img/nuk11.26dd342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/nuk11.jpg
// module id = lCsU
// module chunks = 0